import React, { useState } from 'react';

import { Box, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';

import SelectField from '../../../../../common/select_field';
import { getReservationStoreStatusOptions } from '../../../../../common/utils/reservation_utils';
import { isNullOrUndefined } from '../../../../../../core/utils/misc_utils';
import useNotification from '../../../../../../core/hooks/use_notification';
import { updateReservationStoreStatusAction } from '../../../../../../features/reservation/update_reservation_store_status';
import { updateReservationStoreStatusNotificationData } from '../../../../../../core/utils/notification_utils';
import { ApiRequestStatusEnum } from '../../../../../../core/enums/common/api';

const ReservationStoreStatusFormSelect = ({ reservationId, storeStatus, refreshReservations, center }) => {
    const dispatch = useDispatch();
    const { showNotification } = useNotification();

    const [newStatus, setNewStatus] = useState(storeStatus);

    const [isUpdating, setIsUpdating] = useState(false);

    const onSelectSearchCodeChange = (event) => {
        const status = event.target.value;
        setNewStatus(status);
        setIsUpdating(true);

        dispatch(updateReservationStoreStatusAction({ reservationId, form: { status } }))
            .then(response => {
                showNotification(updateReservationStoreStatusNotificationData(response));
                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    refreshReservations();
                }
            })
            .finally(() => setIsUpdating(false));
    };

    if (isNullOrUndefined(storeStatus)) {
        return null;
    }

    return (
        <Box sx={ { display: 'flex', justifyContent: center ? 'center' : 'flex-start', minWidth: 150 } }>
            { isUpdating ? (
                <CircularProgress size={ 24 }/>
            ) : (
                <SelectField
                    label={ 'Status' }
                    size="small"
                    value={ newStatus }
                    onChange={ onSelectSearchCodeChange }
                    options={ getReservationStoreStatusOptions }
                    sx={ { width: '100%', minWidth: 150 } }
                />
            ) }
        </Box>
    );
};

export default ReservationStoreStatusFormSelect;